import { arrayMove } from "@dnd-kit/sortable";

type ColumnId = string;

export function getNextColumnOrderOnDrag({
  activeId,
  overId,
  pinnedLeftSet,
  currentOrder,
  visibleOrder,
}: {
  activeId: ColumnId;
  overId: ColumnId;
  pinnedLeftSet: ReadonlySet<ColumnId>;
  currentOrder: ColumnId[];
  visibleOrder: ColumnId[];
}): ColumnId[] | null {
  if (pinnedLeftSet.has(activeId)) return null;

  const visibleSet = new Set(visibleOrder);
  const nonPinnedVisible: ColumnId[] = [];
  for (const id of visibleOrder) {
    if (!pinnedLeftSet.has(id)) nonPinnedVisible.push(id);
  }

  const fromIndex = nonPinnedVisible.indexOf(activeId);
  if (fromIndex === -1) return null;

  // Compute drop index within non-pinned visible block.
  let toIndex = nonPinnedVisible.indexOf(overId);
  if (pinnedLeftSet.has(overId)) toIndex = 0;
  if (toIndex === -1) return null;

  // Reorder only non pinned visible ids.
  const reorderedNonPinned = arrayMove(nonPinnedVisible, fromIndex, toIndex);

  // Rebuild full order (keep pinned + hidden in place).
  const nextOrder = [...currentOrder];
  let nonPinnedVisibleIndex = 0;

  for (let i = 0; i < nextOrder.length; i++) {
    const id = nextOrder[i];
    if (pinnedLeftSet.has(id)) continue;
    if (!visibleSet.has(id)) continue;

    const replacement = reorderedNonPinned[nonPinnedVisibleIndex];
    if (replacement) {
      nextOrder[i] = replacement;
    }
    nonPinnedVisibleIndex++;
  }

  return nextOrder;
}
